const NESTED_MARKDOWN_IMAGE_LINK_PATTERN =
  /!\[([^\]]*)\]\(\[([^\]]+)]\(([^)\s]+)\)\)/g;

/** Repairs image URLs that were wrapped by Markdown link autolinking. */
export function repairNestedMarkdownImageLinks(markdown: string) {
  return markdown.replace(
    NESTED_MARKDOWN_IMAGE_LINK_PATTERN,
    (original, alt: string, label: string, destination: string) =>
      label === destination ? `![${alt}](${destination})` : original,
  );
}
